import CasFormInput from '@cas/components/inputs/cas-form-input/CasFormInput';
import { useTranslation } from 'react-i18next';
import { FieldValues, useWatch } from 'react-hook-form';
import {
  mapProvidersWithLayerName,
  mapProvidersWithUrl,
  UiSettingsModel,
} from '@casops/store/apis/settingsApi';
import CasFormDropdown from '@cas/components/inputs/cas-form-dropdown/CasFormDropdown';
import { useMapProviderOptions } from './useMapProviderOptions';
import { UseSettingsFormTabsProps } from '../form/useSettingsFormTabs';
import CasFormConditionalDisplay from '@cas/components/inputs/cas-form-conditional-display/CasFormConditionalDisplay';

export interface MapProviderControlsProps<TFormValues extends FieldValues>
  extends UseSettingsFormTabsProps<TFormValues> {}

export function MapProviderControls({
  control,
  resetField,
}: UseSettingsFormTabsProps<UiSettingsModel>) {
  const { t } = useTranslation();

  const watchProviderType = useWatch({ control, name: 'map.providerType' });

  const mapProviderOptions = useMapProviderOptions();

  return (
    <>
      <CasFormDropdown
        control={control}
        items={mapProviderOptions}
        name="map.providerType"
        label={t('Fields.MapProvider')}
      />

      <CasFormConditionalDisplay
        show={mapProvidersWithUrl.includes(watchProviderType)}
        name="map.uri"
        resetField={resetField}
      >
        <CasFormInput control={control} name="map.uri" label={t('Fields.Url')} />
      </CasFormConditionalDisplay>

      <CasFormConditionalDisplay
        show={mapProvidersWithLayerName.includes(watchProviderType)}
        name="map.layerName"
        resetField={resetField}
      >
        <CasFormInput control={control} name="map.layerName" label={t('Fields.MapLayerName')} />
      </CasFormConditionalDisplay>

      <CasFormInput
        control={control}
        name="map.maxZoom"
        label={t('Fields.MaxZoom')}
        type="number"
      />
      <CasFormInput
        control={control}
        name="map.maxNativeZoom"
        label={t('Fields.MaxNativeZoom')}
        type="number"
      />
    </>
  );
}

export default MapProviderControls;
